import config from '@config';

/**
 * Formatea un precio según la moneda configurada
 * @param {number} price - El precio a formatear
 * @returns {string} - El precio formateado
 */
export function formatPrice(price) {
  if (!price && price !== 0) return '0';
  
  const currency = config.storeSettings.currency;
  
  // Convertir a string y asegurar que sea un número válido
  const priceStr = price.toString();
  
  // Formato según la moneda
  switch (currency) {
    case 'MXN': // Pesos mexicanos - usar comas para miles
      return priceStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
    case 'CLP': // Pesos chilenos - usar puntos para miles
      return priceStr.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    
    case 'USD': // Dólares - usar comas para miles
      return priceStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
    case 'EUR': // Euros - usar puntos para miles
      return priceStr.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    
    default: // Por defecto usar comas (formato internacional)
      return priceStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
} 